import { FC } from 'react'
import { useParams } from 'react-router-dom'
import {
  InsightFilterTab,
  SmartInsight,
  SmartInsightsAIRecommendations,
} from 'src/charts/SmartInsightsAIRecommendations'
import { useGetReviewAnalysisSmartInsightsQuery } from 'src/reactQuery/useGetReviewAnalysisSmartInsightsQuery'
import { useReviewAnalysisDateRange } from 'src/hooks/useReviewAnalysisDateRange'

// The review taxonomy (review-analysis-ops CATEGORIES). Insights still on the
// older categories show under All until they are re-sorted.
const REVIEW_INSIGHT_FILTER_TABS: InsightFilterTab[] = [
  { key: 'all', label: 'All' },
  { key: 'customer_experience', label: 'Customer Experience' },
  { key: 'product_service', label: 'Product & Service' },
  { key: 'operations', label: 'Operations' },
  { key: 'pricing_value', label: 'Pricing & Value' },
  { key: 'opportunities', label: 'Opportunities' },
  { key: 'crisis_warnings', label: 'Crisis Warnings' },
]

interface ReviewSmartInsightsProps {
  facilityId?: string
  platformId?: string
}

export const ReviewSmartInsights: FC<ReviewSmartInsightsProps> = ({
  facilityId,
  platformId,
}) => {
  const { campaignId = '' } = useParams<{ campaignId: string }>()
  // Same window as every other widget on the page — the endpoint has always
  // accepted ?from&?to; the panel just never sent them, so insights were
  // unfiltered and their percentages divided by lifetime review counts.
  const dateRange = useReviewAnalysisDateRange()
  const { data, isLoading } = useGetReviewAnalysisSmartInsightsQuery({
    campaignId,
    facilityId,
    from: dateRange?.from,
    platformId,
    to: dateRange?.to,
  })

  return (
    <SmartInsightsAIRecommendations
      data={
        data
          ? {
              hasInsights: data.hasInsights,
              insights: (data.insights ?? []) as unknown as SmartInsight[],
            }
          : undefined
      }
      filterTabs={REVIEW_INSIGHT_FILTER_TABS}
      homePageVariant
      isLoading={isLoading}
      modalMetricsVariant="review"
    />
  )
}
